
import { Component, Inject, Mixins } from 'vue-property-decorator'
import Testable from '@/mixins/Testable'

@Component({})
export default class FormValidationResults extends Mixins(Testable) {
	@Inject('$validator') $validator

	scrollToError(error) {
		let foundField = this.$validator.fields.find({ id: error.id })
		if (!foundField && this.$validator._base) {
			foundField = this.$validator._base.fields.find({ id: error.id })
		}
		if (foundField) {
			foundField.el.scrollIntoView({ behavior: 'smooth' })
		}
	}
}
